import React from 'react';

type Props = {
  url: string | undefined;
  onBack(): void;
};

export default function NeedFareharborOrderUpdatePage(props: Props) {
  return (
    <>
      <header>
        <h4>You’ll need to update the order in Fareharbor</h4>
      </header>
      <main>
        <div className='request-refund-modal__page-content'>
          <p>
            For FareHarbor bookings, any order changes must be made directly in
            FareHarbor. Once the update is saved, a refund request will be
            created automatically if the change requires a refund.
          </p>
          <b>Steps</b>
          <ol>
            <li>Open the order in FareHarbor.</li>
            <li>Make and save the necessary changes there.</li>
            <li>
              If the change leads to a refund, the refund request will be
              created automatically.
            </li>
          </ol>
        </div>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions modal__actions--between'>
          <button
            key='back'
            className='btn btn-secondary btn--wide'
            type='button'
            onClick={props.onBack}
          >
            Back
          </button>
          <a
            key='fareharborLink'
            href={props.url}
            target='_blank'
            rel='noreferrer'
            className='btn btn-primary btn--wide'
          >
            Open in FareHarbor
          </a>
        </menu>
      </footer>
    </>
  );
}
